import { Component, OnInit, Input } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';

@Component({
  selector: 'smartflip-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
  imports: [IonicModule],
  standalone: true,
})
export class AlertDialogComponent implements OnInit {
  @Input() message: string = '';

  continue() {
    this.modalController.dismiss(true);
  }

  cancel() {
    this.modalController.dismiss(false);
  }

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    const DEFAULT_MESSAGE = 'Would you like to continue?';

    if (!this.message) {
      this.message = DEFAULT_MESSAGE;
    }
  }
}
